import Router from 'vue-router'
import { getToken, redirectToLogin } from 'minerva-ui-sdk'
import labelingRouter from './labeling'
import workspaceRouter from './workspace'
import miscellaneousRouter from './miscellaneous'
import { Plugins } from "../acl/plugins";
import store from "../store";
import { aclService } from "../acl/service";
import Vue from 'vue';

function defaultLink() {
  const workspace = process.env.VUE_APP_DEFAULT_WORKSPACE;
  if (workspace) {
    return `/workspace/${workspace}`
  }
  return null
}

export const router = new Router({
  mode: 'history',
  // base: process.env.VUE_APP_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: defaultLink(),
      component: () => import('@/views/Home'),
      meta: {}
    },
    {
      path: '/model/:mid/training',
      name: 'model-training',
      component: () => import('@/views/common/ModelTrainingPage'),
      meta: {}
    },
    {
      path: '/workspace/:workspace',
      name: 'workspace',
      redirect: '/workspace/:workspace/labeling',
      props: true,
      component: () => import('@/views/Workspace'),
      meta: {},
      children: [
        ...workspaceRouter,
        ...miscellaneousRouter,
        {
          path: ':key/:step/',
          name: 'workspace.labeling.key',
          component: () => import('@/views/Labeling'),
          meta: { hidden: true, title: '标注' },
          children: [
            ...labelingRouter,
            {
              path: ':ui',
              name: 'workspace.key.other',
              component: () => import('@/views/Blank'),
              meta: {}
            }
          ]
        }]
    }
  ]
});

const checkAuth = async () => {
  const token = getToken();
  if (token) {
    const res = await store.dispatch('GetInfo');
    return res;
  }
};

router.beforeEach(async (to, from, next) => {
  if (process.env.VUE_APP_DEBUG) {
    next();
    return
  }
  const access = await checkAuth();
  if (access) {
    const accountResourceAcl = await aclService.getAccountResourceAcl();
    Vue.localStorage.set('accountResourceAcl', JSON.stringify(accountResourceAcl));
    const permission = await Plugins.routerPermissionCheck(to);
    if (permission) {
      next()
    }
  } else {
    redirectToLogin()
  }
});
